<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>DESPACHO DE ORDENES DE COMPRA PENDIENTES</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listadoP" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> En Proceso de Coordinación</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mr-2" @click="editar(item, 'P')">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="black" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verP(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>Ver EI040</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-data-table dense :headers="headers" :items="listadoE" :single-expand="true" locale="es-ar"
                class="elevation-1" :items-per-page="200" hide-default-footer :loading="loadtable"
                loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <v-toolbar-title center>
                            <font color="green"> En Proceso de Despacho</font>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small class="mr-2" @click="editar(item, 'E')">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="black" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verE(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>Ver EI040</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <Editar :visible="showEditar" :codgral="editedItem.codgral" :codoc="editedItem.codoc"
                @close="showEditar = false">
            </Editar>
            <Ver :visible="showVer" :codgral="editedItem.codgral" :codoc="editedItem.codoc" @close="showVer = false">
            </Ver>
        </v-app>
    </div>
</template>


<script>
import axios from "../../axios-auth";
import Editar from "../Lanzamiento/Despacho.vue";
import Ver from "../Lanzamiento/Informe.vue";
import moment from "moment";

export default {
    components: { Editar, Ver },
    data: (vm) => ({
        usuario: "",
        editedItem: {
            fact: "",
            codgral: "",
            empresa: "",
            codoc: "",
            responsable: "",
        },
        editedIndex: -1,
        listadoP: [],
        listadoE: [],
        showEditar: false,
        showVer: false,
        loadtable: false,
        headers: [
            { text: "N° de Cliente", value: "codgral", sortable: false },
            { text: "Nombre Empresa", value: "empresa", sortable: false },
            { text: "N° de Orden de Compra", value: "codoc", sortable: false },
            { text: "Provisión", value: "provision", sortable: false },
            { text: "Referente Proyecto", value: "lider", sortable: false },
            { text: "N° de OT", value: "numot", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],

    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                //this.usuario = this.$store.state.nombre.toString().trim();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarListados() {
            this.vaciarModels();
            this.loadtable = true;
            let self = this;
            axios
                .get("/Lanzamiento/Listadodespacho?", {
                    params: {
                        tipo: "O",
                    },
                })
                .then((response) => {
                    response.data.forEach(element => {
                        if (element.estado == "P") {
                            self.listadoP.push(element);
                        }
                        if (element.estado == "E") {
                            self.listadoE.push(element);
                        }
                    });
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listadoP = [];
                    self.listadoE = [];
                    console.log(error);
                });
        },
        verP(item) {
            this.editedIndex = this.listadoP.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },
        verE(item) {
            this.editedIndex = this.listadoE.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },
        editar(item, flag) {
            if (flag == "P") {
                this.editedIndex = this.listadoP.indexOf(item);
            }
            if (flag == "E") {
                this.editedIndex = this.listadoE.indexOf(item);
            }
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listadoP = [];
            this.listadoE = [];

        },
    },
};
</script>
